import React from 'react';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import EditIcon from '@mui/icons-material/Edit';
import FolderIcon from '@mui/icons-material/Folder';
import GroupIcon from '@mui/icons-material/Group';
import BadgeIcon from '@mui/icons-material/Badge';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { Container, Header, HeaderLeft, BackButton, Title, Content, MainSection } from '../common/styles';
import { StyledCard, StyledIconButton } from '../LandingPage/styles';

const cards = [
  {
    id: 'actions',
    title: 'Actions',
    description: 'Manage available actions (read, create, update, delete, manage, publish)',
    icon: <EditIcon />,
    path: '/permissions/actions',
    customIconStyle: { 
      backgroundColor: '#2196F3',
    }
  },
  {
    id: 'resources',
    title: 'Resources',
    description: 'Configure resources (FeedbackSession, CV, Employee, etc.)',
    icon: <FolderIcon />,
    path: '/permissions/resources',
    customIconStyle: { 
      backgroundColor: '#4CAF50',
    }
  },
  {
    id: 'roles',
    title: 'Roles',
    description: 'Define roles (Administrator, People Partner, Team Representative, etc.)',
    icon: <GroupIcon />,
    path: '/permissions/roles',
    customIconStyle: { 
      backgroundColor: '#FF9800',
    }
  },
  {
    id: 'employee-roles',
    title: 'Individual Roles',
    description: 'View and manage individual role assignments',
    icon: <BadgeIcon />,
    path: '/permissions/employee-roles',
    customIconStyle: {
      backgroundColor: '#00BCD4',
    }
  },
  {
    id: 'employee-overrides',
    title: 'Individual Override Permissions',
    description: 'Manage individual permission overrides (Grant/Deny)',
    icon: <AdminPanelSettingsIcon />,
    path: '/permissions/employee-overrides',
    customIconStyle: {
      backgroundColor: '#9C27B0',
    }
  }
];

const Permissions = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Header>
        <HeaderLeft>
          <BackButton onClick={() => navigate('/')}>
            <FaArrowLeft /> Back to Dashboard
          </BackButton>
          <Title>Permissions</Title>
        </HeaderLeft>
      </Header>

      <Content>
        <MainSection>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Manage roles, resources, actions, and permissions for your organization
          </Typography>
          
          <Grid container spacing={3}>
            {cards.map((card) => (
              <Grid item xs={12} md={6} key={card.id}>
                <StyledCard onClick={() => navigate(card.path)}>
                  <StyledIconButton
                    sx={{ 
                      ...card.customIconStyle,
                      '&:hover': {
                        ...card.customIconStyle
                      }
                    }}
                  >
                    {card.icon}
                  </StyledIconButton>
                  <Typography variant="h6" align="center">{card.title}</Typography>
                  <Typography variant="body2" color="textSecondary" align="center">
                    {card.description}
                  </Typography>
                </StyledCard>
              </Grid>
            ))}
          </Grid>
        </MainSection>
      </Content>
    </Container>
  );
};

export default Permissions;